import React, { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { BookOpenCheckIcon, XIcon } from "lucide-react";
import { buyers } from "../data/buyers";
import { images } from "../data/offer";
const SHOW_MS = 5000;
const GAP_MS = 9000;
export function PurchasePopup() {
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(false);
  const [minutes, setMinutes] = useState(2);
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => {
    if (dismissed) return;
    let hideTimer: number;
    const show = () => {
      setIndex(Math.floor(Math.random() * buyers.length));
      setMinutes(Math.floor(Math.random() * 14) + 1);
      setVisible(true);
      hideTimer = window.setTimeout(() => setVisible(false), SHOW_MS);
    };
    const first = window.setTimeout(show, 6000);
    const loop = window.setInterval(show, SHOW_MS + GAP_MS);
    return () => {
      window.clearTimeout(first);
      window.clearTimeout(hideTimer);
      window.clearInterval(loop);
    };
  }, [dismissed]);
  const buyer = buyers[index];
  return <div className="pointer-events-none fixed bottom-[96px] left-3 right-3 z-50 sm:left-5 sm:right-auto sm:w-[340px]" aria-live="polite" data-id="element-255" data-mp="117o1lpknur0f">
      <AnimatePresence data-id="element-256" data-mp="1fv0w43sg472y">
        {visible && !dismissed && <motion.div key={`${buyer.name}-${minutes}`} initial={{
        opacity: 0,
        y: 16,
        scale: 0.96
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 16,
        scale: 0.96
      }} transition={{
        duration: 0.22,
        ease: [0.23, 1, 0.32, 1]
      }} className="pointer-events-auto relative flex items-center gap-3 rounded-2xl border border-line bg-white p-3 pr-9 shadow-[0_16px_40px_-12px_rgba(14,26,43,0.35)]" data-id="element-257" data-mp="1axqu7onve2y8">
            <img src={images.hero} alt="" className="h-14 w-14 shrink-0 rounded-xl bg-cream object-contain" data-id="element-258" data-mp="28jojq60o38jo" />
            <div className="min-w-0" data-id="element-259" data-mp="23kblyq89ch2b">
              <p className="text-sm font-bold leading-snug text-ink" data-id="element-260" data-mp="23nhbu7opnmz3">
                {buyer.name} <span className="font-medium text-muted" data-id="element-261" data-mp="2ao1l4sdbzfn4">from {buyer.country}</span>
              </p>
              <p className="text-[13px] leading-snug text-ink" data-id="element-262" data-mp="2fm38vqlpc34x">just purchased the Facelift Blueprint™ digital book</p>
              <p className="mt-0.5 flex items-center gap-1 text-[11px] font-semibold text-cta" data-id="element-263" data-mp="2kko57exu22o3">
                <BookOpenCheckIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-264" data-mp="2pjrbt3tgogy6" />
                Verified purchase · {minutes} min ago
              </p>
            </div>
            <button type="button" onClick={() => setDismissed(true)} aria-label="Dismiss notification" className="absolute right-2 top-2 grid h-6 w-6 place-items-center rounded-full text-muted hover:bg-sand" data-id="element-265" data-mp="1wxy90u8612be">
              <XIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-266" data-mp="198dlrz4zbiwb" />
            </button>
          </motion.div>}
      </AnimatePresence>
    </div>;
}